import React from 'react'

export const OrderSummary = () => {
  return (
    <div className="lg:p-8 p-3 h-full bg-gray-100 border-gray-300">
      <div className="lg:w-4/5 xl:w-9/12 lg:mr-auto">
        <div className="md:flex space-y-4 gap-5">
          <div className="md:w-1/5 w-6/12  bg-white border rounded overflow-hidden content-center grid p-2"><img src="images/product-01.png" alt="Product" /></div>
          <div className="w-3/5 text-sm">
            <h4>Vincent Chase</h4>
            <h5>Silver Blue Full Rim Square Eyeglasses</h5>
            <h5 className="text-gray-500">Size: Wide</h5>
          </div>
          <div className="text-cyan-500 w-1/5">$98</div>
        </div>
        <hr className="my-4" />
        <div className="flex gap-5">
          <div className="lg:w-4/5">
            <input type="text" name="" placeholder="Discount Code" className="border border-gray-300 p-3 my-3 rounded text-sm w-full" />
          </div>
          <div className="w-1/5">
            <button className="bg-cyan-500 text-white rounded py-[10px] px-8 mt-3 tracking-widest">Apply</button>
          </div>
        </div>
        <hr className="my-4" />
        <div className="text-sm text-gray-600 leading-6">
          <div className="flex justify-between">
            <div>Subtotal</div>
            <div>$98.00</div>
          </div>
          <div className="flex justify-between">
            <div>Shipping</div>
            <div>$20.00</div>
          </div>
          <hr className="my-2" />
          <div className="flex justify-between text-gray-800">
            <div className="font-medium text-base">Total</div>
            <div className="text-2xl">$118.00</div>
          </div>
        </div>
      </div>
      <div className="content-end md:hidden">
          <hr className="mt-6 mb-4" />
          <div className="md:flex grid grid-cols-2 gap-4 text-cyan-500 text-sm font-light">
            <a href="http://" target="_blank" rel="noopener noreferrer">Refund policy</a>
            <a href="http://" target="_blank" rel="noopener noreferrer">Shipping policy</a>
            <a href="http://" target="_blank" rel="noopener noreferrer">Privacy policy</a>
            <a href="http://" target="_blank" rel="noopener noreferrer">Terms of service</a>
          </div>
        </div>
    </div>
  )
}